'use strict';

define('shopCode', [], function () {
	const shop = {};
	const SHOP_URL_MAP = {
		// 目前商城只部署了pre和prod
		dev: 'http://dev-aidot-mall.arnoo.com',
		test: 'http://test-aidot-mall.arnoo.com',
		pre: 'http://pre-aidot-mall.arnoo.com',
		prod: 'https://www.aidot.com',
	};
	shop.SHOP_URL = SHOP_URL_MAP[window.config.RTE] || '';
	shop.SHOP_HOST = (SHOP_URL_MAP[window.config.RTE] || '').replace(/^https?:\/\//, '');

	const validDuration = 115 * 60 * 1000;
	// const validDuration = 1 * 60 * 1000;
	let codeExpiresTime = 0;
	let shopCode = '';
	let codeInterval = 0;

	// console.log('-----初始化 shopCode----');
	shop.setSchedule = function () {
		if (codeInterval) {
			// console.log('-----shopCode 已有轮询----');
			return;
		}
		shop.initShopCode();
		// console.log('-----shopCode 开始轮询----');
		codeInterval = setInterval(() => {
			// console.log('-----shopCode 轮询更新 code----');
			shop.initShopCode();
		}, validDuration);
	};

	shop.unsetSchedule = function () {
		if (codeInterval) {
			// console.log('-----shopCode 结束已有轮询----');
			clearInterval(codeInterval);
			codeInterval = 0;
		}
	};

	shop.initShopCode = function (resolve, reject) {
		socket.emit('user.getShopCode', function (err, newCode) {
			// console.log('-----shopCode user.getShopCode----', err, newCode);
			if (err) {
				codeExpiresTime = 0;
				if (reject) {
					reject(err);
				}
				return;
			}
			codeExpiresTime = Date.now() + validDuration;
			shopCode = newCode.code;
			if (resolve) {
				resolve(shopCode);
			}
		});
	};

	shop.getShopCode = async function () {
		return new Promise(function (resolve, reject) {
			if (shopCode && Date.now() < codeExpiresTime) {
				// console.log('-----shopCode 返回现有code，更新code', shopCode);
				resolve(shopCode);
				shopCode = '';
				codeExpiresTime = 0;
				shop.unsetSchedule();
				shop.setSchedule();
			} else {
				// console.log('-----shopCode 没有现成code或者code过期，更新code', shopCode);
				shop.initShopCode(resolve, reject);
			}
		});
	};

	return shop;
});
